import {useEffect} from 'react'
import utils from 'helpers/utils';
import logger from 'helpers/logger';
import constants from 'helpers/constants';
import {api} from 'helpers/hooks/api';
import {useAuth} from 'components/organisms/Providers/AuthProvider/AuthProvider';
import {useRouter} from 'components/organisms/Providers/RouteProvider/RouteProvider';
import {useSnackbar} from 'components/organisms/Providers/SnackbarProvider/SnackbarProvider';

const AuthIntercept = (props) => {
  const auth = useAuth();

  const router = useRouter();
  const snackbar = useSnackbar();

  useEffect(() => {
    const authInterceptor = api.interceptors.response.use((response) => {
      return response;
    }, (error) => {
      const location = router.state?.location;
      const intercept = !error?.request?.responseURL?.includes('intercept=false');

      if (intercept) {
        if ((error?.response?.status === constants.http.status.conflict && error.response?.data?.userDisabled) ||
            (error?.response?.status === constants.http.status.conflict && error.response?.data?.teamDisabled) ||
            (error?.response?.status === constants.http.status.conflict && error.response?.data?.clientDisabled) ||
            (error?.response?.status === constants.http.status.conflict && error.response?.data?.tokenDisabled) ||
            error?.response?.status === constants.http.status.unauthorized) {

          if (error.response.status === constants.http.status.unauthorized) {
            snackbar.show('Your session has expired. Please login again', null,
              {color: 'warning', autoHideDuration: constants.delay.warning});
          } else if (error.response?.data?.teamDisabled) {
            snackbar.show('This team has been deactivated', null,
              {color: 'error', autoHideDuration: constants.delay.error});
          } else if (error.response?.data?.userDisabled || error.response?.data?.clientDisabled) {
            snackbar.show('Your account has been suspended', null,
              {color: 'error', autoHideDuration: constants.delay.error});
          } else if (error.response?.data?.tokenDisabled) {
            snackbar.show('Your token has been disabled', null,
              {color: 'error', autoHideDuration: constants.delay.error});
          }

          if (router) {
            const loginOutPath = utils.comparePath(location?.pathname, '/auth/login') ||
              utils.comparePath(location?.pathname, '/auth/logout');

            const state = {
              from: !loginOutPath ? location : {
                ...location?.state?.from,
                pathname: utils.validRedirect(location?.state?.from),
                search: ''
              }
            };
            router.navigate('/auth/logout', {replace: true, state});
          }
        } else if (error?.response?.status === constants.http.status.forbidden) {
          logger.trace('Not authorized to see this information', error);

          if (auth?.loggedIn) {
            snackbar.show('You are not authorized to see this information. You are redirected to an allowed page.', null,
              {color: 'warning', autoHideDuration: constants.delay.warning});

            if (router) {
              router.navigate('/', {replace: true});
            }
          } else {
            snackbar.show('Your session has expired. Please login again', null,
              {color: 'warning', autoHideDuration: constants.delay.warning});

            if (router) {
              const loginOutPath = utils.comparePath(location?.pathname, '/auth/login') ||
                utils.comparePath(location?.pathname, '/auth/logout');

              const state = {
                from: !loginOutPath ? location : {
                  ...location?.state?.from,
                  pathname: utils.validRedirect(location?.state?.from),
                  search: ''
                }
              };

              router.navigate('/auth/logout', {replace: true, state});
            }
          }
        }
      }

      return Promise.reject(error);
    });

    return () => {
      api.interceptors.response.eject(authInterceptor);
    }
  }, [snackbar, router, auth?.authId, auth?.loggedIn]);

  return props.children;
};

AuthIntercept.propTypes = {
}

export default AuthIntercept;
